import React, { ReactNode } from 'react';
import { Tooltip } from 'antd';
import cx from 'classnames';

import CategoryCountLabel from '../CategoryCountLabel';
import './CategoryForm.scss';

interface IFormProps {
  className?: string;
  children?: ReactNode;
}
const CategoryForm = ({ className, children }: IFormProps): JSX.Element => {
  return <div className={cx('category-common-form', className)}>{children}</div>;
};

export const Row = ({ className, children }: IFormProps): JSX.Element => {
  return <div className={cx('category-common-form-row', className)}>{children}</div>;
};

type WithCount = {
  withCount: true;
  content: string;
  maxLength: number;
};
type WithoutCount = {
  withCount?: false;
  content?: string;
  maxLength?: number;
};
type Label = {
  className?: string;
  text: string | number;
  required?: boolean;
  tooltip?: ReactNode;
} & (WithCount | WithoutCount);
export const Label = ({ className, text, required, tooltip, withCount, content, maxLength }: Label): JSX.Element => {
  const label = (
    <>
      <label>{text}</label>
      {tooltip ? (
        <Tooltip title={tooltip} trigger="click">
          <button className="caution-btn">!</button>
        </Tooltip>
      ) : null}
    </>
  );
  return (
    <div className={cx('category-common-form-label', className, { required })}>
      {withCount ? <CategoryCountLabel content={content} label={label} maxLength={maxLength} /> : label}
    </div>
  );
};

export const Content = ({ className, children }: IFormProps): JSX.Element => {
  return <div className={cx('category-common-form-content', className)}>{children}</div>;
};

export default CategoryForm;
